var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogBulkPlannedSchedule" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "b-field",
            { attrs: { label: "בחר קורס" } },
            [
              _c(
                "b-select",
                {
                  attrs: { loading: _vm.coursesLoading, expanded: "" },
                  model: {
                    value: _vm.selectedCourseId,
                    callback: function ($$v) {
                      _vm.selectedCourseId = $$v
                    },
                    expression: "selectedCourseId",
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("בחר קורס")]
                  ),
                  _vm._l(_vm.courses, function (course) {
                    return _c(
                      "option",
                      { key: course.id, domProps: { value: course.id } },
                      [_vm._v(_vm._s(course.name))]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-field",
            {
              attrs: {
                label:
                  "הדבק רשימת מזהי משתמשים (מופרדים בפסיק או שורה חדשה, עד 200)",
              },
            },
            [
              _c("b-input", {
                attrs: {
                  type: "textarea",
                  rows: "8",
                  placeholder: "232, 343, 3422",
                },
                model: {
                  value: _vm.text,
                  callback: function ($$v) {
                    _vm.text = $$v
                  },
                  expression: "text",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "counter" }, [
            _vm._v("מזהים שזוהו: "),
            _c("strong", [_vm._v(_vm._s(_vm.ids.length))]),
          ]),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              type: "is-primary",
              label: "הורד",
            },
            on: { click: _vm.submit },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "ביטול" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }